import { createListViewContainer } from 'factories/ListView'
import selectors from 'selectors'
import actions from 'actions/reports/dataTransferAuditReport'
import Component from 'components/Reports/DataTransferAuditReport'

export default createListViewContainer({ actions, selectors: selectors.dataTransferAuditReport })(Component)
